import common from './common';
import DrawingScene from './scenes/DrawingScene';
import HelpScene from './scenes/HelpScene';
import SaveData from './SaveData';
import SplashScene from './scenes/SplashScene';
import SelectScene from './scenes/SelectScene';

export default class Application {
	constructor() {
		common.saveData = new SaveData();
	}

	init() {
		this.showSplashScene();
		//this.showDrawingScene();
		//this.showSelectScene();
	}

	showSplashScene() {
		const scene = new SplashScene();
		scene.autoAppear = false;

		scene.signals.next.add(() => {
			this.showSelectScene();
		});

		this.fadeTransition(() => {P3.scene.show(scene);}, () => {scene.appear();});
		return scene;
	}

	showSelectScene() {
		const scene = new SelectScene();
		scene.autoAppear = false;

		scene.signals.previous.add(() => {
			this.showSplashScene();
		});
		scene.signals.next.add((data) => {
			this.showDrawingScene(data);
		});

		this.fadeTransition(() => {P3.scene.show(scene);}, () => {scene.appear();});
		return scene;
	}

	showDrawingScene(data) {
		const scene = new DrawingScene(data);
		scene.autoAppear = false;

		scene.signals.next.add(() => {});
		scene.signals.previous.add(() => {
			this.showSelectScene();
		});
		scene.signals.pause.add(() => {
			const help = this.showHelpScene();
			help.signals.home.add(function() {
				this.showSplashScene();
			}, this, 1);
		});

		this.fadeTransition(() => {P3.scene.show(scene);}, () => {scene.appear();});
		return scene;
	}

	showHelpScene() {
		const scene = new HelpScene();

		scene.signals.next.add(() => {
			P3.scene.remove();
		});
		scene.signals.previous.add(() => {});

		P3.scene.add(scene);
		return scene;
	}

	fadeTransition(a, b, scope) {
		scope = scope || window;

		const transition = new P3.FadeTransition(0x0);
		common.transitions.addChild(transition);

		transition.signals.in.add(() => {
			transition.out();
			a && a.call(scope);
		});
		transition.signals.out.add(() => {
			transition.destroy();
			b && b.call(scope);
		});
		transition.in();
	}
}